import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatSelectChange } from '@angular/material/select';
import { PermissionControlType, PermissionControlTypeValue, PermissionRole, PermissionValue } from '@core/models';
import { NgTemplateOutlet } from '@angular/common';

export type PermissionRoleChangeArgs = { payload: PermissionValue; permissionRole: PermissionRole };

@Component({
  selector: 'app-settings-permissions-value',
  standalone: true,
  imports: [MatCheckboxModule, MatSelectModule, MatFormFieldModule, NgTemplateOutlet],
  templateUrl: './permission-value.component.html',
  styleUrl: './permission-value.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermissionValueComponent {
  @Input() permissionRole: PermissionRole;
  @Input() readOnly = false;
  @Output() change = new EventEmitter<PermissionRoleChangeArgs>();

  PermissionControlType = PermissionControlType;
  PermissionControlTypeValue = PermissionControlTypeValue;
  PermissionValue = PermissionValue;
  changeRouter: { [key in PermissionControlType]: (event: MatCheckboxChange | MatSelectChange) => void } = {
    [PermissionControlType.Boolean]: ({ checked }: MatCheckboxChange): void => {
      this.change.emit({
        payload: checked ? PermissionValue.True : PermissionValue.False,
        permissionRole: this.permissionRole,
      });
    },
    [PermissionControlType.AllOrNone]: ({ checked }: MatCheckboxChange): void => {
      this.change.emit({
        payload: checked ? PermissionValue.Everything : PermissionValue.NoAccess,
        permissionRole: this.permissionRole,
      });
    },
    [PermissionControlType.AllOrTeamOrNone]: ({ value }: MatSelectChange): void => {
      this.change.emit({ payload: value, permissionRole: this.permissionRole });
    },
    [PermissionControlType.AllOrOwnerOrNone]: ({ value }: MatSelectChange): void => {
      this.change.emit({ payload: value, permissionRole: this.permissionRole });
    },
    [PermissionControlType.AllOrTeamsOrOwnerOrNone]: ({ value }: MatSelectChange): void => {
      this.change.emit({ payload: value, permissionRole: this.permissionRole });
    },
  };
}
